"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  "montalcino": {
    "620ff47e": [{
      "hkey": "4d952938",
      "slug": "centro",
      "name": "Centro",
      "primary": true,
      "skipSearch": false
    }],
    "montalcino": [{
      "hkey": "4d952938",
      "slug": "centro",
      "name": "Centro",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }],
    "c9f93e0d": [{
      "hkey": "22483ce2",
      "slug": "monte-amiata",
      "name": "Monte Amiata",
      "primary": true,
      "skipSearch": false
    }],
    "monte-amiata-scalo": [{
      "hkey": "22483ce2",
      "slug": "monte-amiata",
      "name": "Monte Amiata",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }],
    "70ca1d5b": [{
      "hkey": "aa1231ad",
      "slug": "montalcino",
      "name": "Montalcino",
      "primary": true,
      "skipSearch": false
    }],
    "poggio-alle-mura": [{
      "hkey": "aa1231ad",
      "slug": "montalcino",
      "name": "Montalcino",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "cb0ff183": [{
      "hkey": "0e0f779e",
      "slug": "stazione-sant-angelo-cinigiano",
      "name": "Stazione Sant'Angelo-Cinigiano",
      "primary": true,
      "skipSearch": false
    }],
    "sant-angelo-scalo": [{
      "hkey": "0e0f779e",
      "slug": "stazione-sant-angelo-cinigiano",
      "name": "Stazione Sant'Angelo-Cinigiano",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }]
  }
};
exports["default"] = _default;